export default {
  common: {
    brand: 'USFans Spreadsheet',
    tagline: 'Centro de recursos independiente',
    navHome: 'Inicio',
    navShoppingGuide: 'Guía de compras',
    navGuides: 'Guías',
    navCategories: 'Categorías',
    navResources: 'Recursos',
    navReview: 'Reseña',
    navFaq: 'FAQ',
    visitMain: 'Visitar el sitio principal',
    language: 'Idioma',
    mainSiteUrl: 'https://kaspreadsheet.com',
    footerAbout: 'USFans Spreadsheet es un recurso independiente que organiza la mercancía y la ropa de fanáticos estadounidenses en una estructura sencilla y fácil de explorar, para que encuentres lo que buscas más rápido.',
    footerQuickLinks: 'Enlaces rápidos',
    footerCategories: 'Categorías',
    footerDisclaimer: 'Este sitio web es un recurso informativo independiente y no está afiliado oficialmente a ninguna marca, salvo que se indique explícitamente. Todos los enlaces de productos conducen al sitio web principal.',
    footerRights: 'Todos los derechos reservados.',
    notFoundTitle: 'No se pudo encontrar esta página',
    notFoundText: 'La página que buscas no existe. Vuelve para explorar el centro de recursos.',
  },
  cat: {
    shoes: 'Zapatos',
    hoodies: 'Sudaderas/Suéteres',
    tshirts: 'Camisetas',
    jackets: 'Chaquetas',
    pants: 'Pantalones/Shorts',
    headwear: 'Gorros y sombreros',
    sets: 'Conjuntos',
    underwear: 'Ropa interior/Calzoncillos',
    jersey: 'Camiseta deportiva',
    accessories: 'Accesorios',
    bags: 'Bolsos',
    belts: 'Cinturones',
    perfumes: 'Perfumes',
    other: 'Otras cosas',
  },
};